// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","wrapper":"services_wrapper__s4i6x","noPadding":"services_noPadding__EYAVu"};